<template>
    <div class="bg-color" style="padding-top: 5px;padding-bottom: 10px;transition: none;">
        <div class="tab-bar relative">
            <!--2023.3.6 移除提示，改为新页面打开  @tab-click="changeTab""-->
            <el-tabs v-model="activeTabName" :before-leave="beforeChangeTab">
                <el-tab-pane label="整体" name="data_all" v-if="tabsList.includes('data_all')"></el-tab-pane>
                <el-tab-pane label="OPPO" name="data_1" v-if="tabsList.includes('data_1')"></el-tab-pane>
                <el-tab-pane label="vivo" name="data_3" v-if="tabsList.includes('data_3')"></el-tab-pane>
                <el-tab-pane label="华为" name="data_4" v-if="tabsList.includes('data_4')"></el-tab-pane>
                <el-tab-pane label="华为Ads" name="data_10" v-if="tabsList.includes('data_10')"></el-tab-pane>
                <el-tab-pane label="荣耀" name="data_11" v-if="tabsList.includes('data_11')"></el-tab-pane>
                <el-tab-pane label="小米" name="data_7" v-if="tabsList.includes('data_7')"></el-tab-pane>
                <el-tab-pane label="小米4.0" name="data_37" v-if="tabsList.includes('data_37')"></el-tab-pane>
                <el-tab-pane label="小米海外" name="data_12" v-if="tabsList.includes('data_12')"></el-tab-pane>
                <el-tab-pane label="爱奇艺" name="data_8" v-if="tabsList.includes('data_8')"></el-tab-pane>
                <el-tab-pane label="Apple" name="data_9" v-if="tabsList.includes('data_9')"></el-tab-pane>
            </el-tabs>

            <p class="page-tips absolute">
                <el-link v-matomo="{behaviorCategory: `综合查询分析(${$route.meta.title})`,  name: '使用说明文档' }" :underline="false" type="primary" href="https://ho734vnlan.feishu.cn/docx/C8QBdvkEFoInfIxPqGTchFrnnwd" target="_blank">
                    <span class="underline">使用说明文档</span>
                </el-link>
                <!--<span class="inline-block tal" style="min-width: 75px;">{{lastDataTime||'&#45;&#45;'}}</span>-->
            </p>
        </div>
        <template v-if="isAllowed">
            <template v-if="activeTabName=='data_all'&&false">
                <div class="pb40 bg-color-white">
                    <p class="tac f-hide">
                        <img src="@/assets/img/home-run.png" class="home-run" alt=""
                             style="margin-top: -80px;margin-bottom: -40px;">
                    </p>
                    <h4 class="tac font16px text-color-info">整体查询正在设计中，敬请期待…</h4>
                    <p class="tac mt20">整体查看时将整合拉齐所有渠道的维度与指标，可不分媒体查询各维度各数据指标汇总</p>
                </div>
            </template>
            <div v-else class="page-wrap" :style="{height:pageHeight+'px'}">
                <div class="left-wrap" :style="{width:leftWidth+'px'}">
                    <div class="fix-tool" :class="[isFixedFilterBar=='1'?'':'active','fix-tool']" @click="setConditionAreaState">
                        <span title="未固定：每次查询自动收起" class="icon iconfont icon-jt-guding1"  v-if="isFixedFilterBar=='1'"></span>
                        <span title="固定：每次查询不会自动收起" class="icon iconfont icon-jt-guding1 text-color-primary" v-else></span>

                    </div>
                    <div class="relative full-h" v-show="isShow">
                        <slot name="left">aaa</slot>
                    </div>
                    <SplitBar :direction="isShow?'left':'right'" @toggle="toggleFilterDisplay"/>
                </div>
                <div class="right-content-wrap" :class="fixedTableHeight?'':'fixed-content'">
                    <div class="right-top">
                        <!--<SplitBar :direction="isShowRightTop?'up':'down'" @toggle="toggleConditionDisplay"/>-->
                        <div class="right-top-content">
                            <!--<slot name="top" :is-show="isShowRightTop"></slot>-->
                            <slot name="top"></slot>
                        </div>
                    </div>
                    <div class="right-bottom relative" :class="fixedTableHeight?'':'pb32'" :style="{height:fixedTableHeight?bottomHeight+'px':'auto'}">
                        <slot name="bottom"></slot>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <NoPermissionInfo style="background-color: #fff;">
                <p>此页面可针对所有的媒体进行数据查询分析，覆盖全部维度与指标，灵活配置查询。</p>
            </NoPermissionInfo>
        </template>

    </div>

</template>

<script>
    import {mapGetters} from 'vuex';
    import SplitBar from './splitBar';
    import NoPermissionInfo from '@/components/noPermissionInfo';
    import API from '@/api/dataCenter.js';
    import {undistributeMixin} from '../../mixins/undistributeMixin';

    export default {
        name: "PageWrap",
        components: {
            SplitBar,
            NoPermissionInfo,
        },
        mixins: [undistributeMixin],
        props: {
            isAllowed: {
                required: true,
                type: Boolean,
            },
            lastDataTime:{
                type: String,
            },
            fixedTableHeight:Boolean,
        },
        data() {
            return {
                isShow: true,
                isShowRightTop: true,
                leftWidth: 300,
                pageHeight: 500,
                bottomHeight:300,
                activeTab: {
                    name: '',
                },
                activeTabName: 'data_all',
                isFixedFilterBar:'0',   // 0-关闭 1-开启
            }
        },
        computed: {
            ...mapGetters(['tabs_map']),
            tabsList() {
                let queryAnalysisTabs = this.tabs_map.data_query_analysis || [];
                return queryAnalysisTabs.map(item => item.name);
            },
        },
        created() {
            let matchedRoute = this.$route.matched || [];
            let curRoute = [...matchedRoute].reverse()[0];
            console.log('datacenter pageWrap created',curRoute);
            if(curRoute.name=='data_query_analysis'){
                let allTabs = this.tabs_map.data_query_analysis||[];
                if(allTabs.length>0){
                    // 判断是不是整体分析，如果是整体分析需要跳转到OPPO分析
                    if(allTabs.length==1){
                        this.$router.push(allTabs[0].path);
                    }else{
                        if(allTabs[0].name=='data_all'){
                            this.$router.push(allTabs[1].path);
                        }else{
                            this.$router.push(allTabs[0].path);
                        }
                    }
                }
            }else{
                this.activeTab = curRoute;
                this.activeTabName = this.activeTab.name || 'data_all';
            }
            this.getConditionAreaState();
        },
        mounted() {

            // // 监听本页面resize
            window.addEventListener('resize', this.resizePage);
            this.resizePage();
            setTimeout(()=>{
                let $mainContainer = document.querySelectorAll('.main-container');
                let localStorage = window.localStorage;
                let isWhitePage = localStorage.getItem('whitePage')==='true';
                console.log('queryAnalysis pageWrap mounted setTimeout',$mainContainer);

                if($mainContainer.length<=0){
                    if(!isWhitePage){
                        localStorage.setItem('whitePage','true');
                        window.location.reload();
                    }
                }else{
                    localStorage.removeItem('whitePage');
                }
            },200)
        },
        methods: {
            toggleFilterDisplay() {

                if(this.isShow){
                    this.hideAllFilters('toggle');
                }else{
                    this.showAllFilters();
                }
            },
            toggleConditionDisplay() {
                if(this.isShowRightTop){
                    this.hideAllFilters();
                }else{
                    this.showAllFilters();
                }
            },
            resizePage() {
                this.pageHeight = document.body.clientHeight - 60 - 54;
                this.calcBottomHeight();
                this.$emit('resize')
            },
            calcBottomHeight(){
                this.$nextTick(()=>{
                    let $rightTop = document.querySelector('.right-content-wrap .right-top');
                    if($rightTop){
                        this.bottomHeight = this.pageHeight - $rightTop.clientHeight - 12;
                        this.$emit('toggle',this.isShowRightTop,this.bottomHeight);
                    }
                });
            },
            beforeChangeTab(newName){
                let routeData = this.$router.resolve({
                    name: newName,
                    query: this.$route.query,
                });
                window.open(routeData.href, '_blank');
                return false;
                // return new Promise((resolve, reject)=>{
                //     if(oldName==='data_all'){
                //         this.activeTabName = newName;
                //         this.$router.push(this.activeTabName);
                //         this.$emit('change-tab');
                //         return resolve();
                //     }
                //     this.$confirm('切换tab会导致当前筛选内容清空，确认要切换吗？', '温馨提示', {
                //         confirmButtonText: '确认切换',
                //         type: 'warning',
                //         center: true,
                //         showClose: false,
                //         distinguishCancelAndClose: true,
                //     }).then(()=>{
                //         this.activeTabName = newName;
                //         this.$router.push(this.activeTabName);
                //         this.$emit('change-tab');
                //         resolve();
                //     }).catch(()=>{
                //         reject();
                //     });
                // });
            },
            changeTab() {
                console.log('changeTab');
                // this.$router.push(this.activeTabName);
                // this.$emit('change-tab');
            },
            hideAllFilters(type) {
                if(type=='toggle'){
                    this.isShow = false;
                    this.leftWidth = 0;
                    this.isShowRightTop = false;
                    this.resizePage();
                }else{
                    if(this.isFixedFilterBar=='0') return;
                    this.isShow = false;
                    this.leftWidth = 0;
                    this.isShowRightTop = false;
                    this.resizePage();
                }
            },
            showAllFilters(){
                console.log('showAllFilters');
                this.isShow = true;

                this.leftWidth = 300;
                this.isShowRightTop = true;
                this.resizePage();
            },
            getConditionAreaState(){
                console.log('getConditionAreaState');
                API.getConditionAreaState().then(res=>{
                    let resData = res.data||{};
                    this.isFixedFilterBar = resData.state||'0';
                })
            },
            setConditionAreaState(){
                let newState = this.isFixedFilterBar=='1'?'0':'1';
                this.isFixedFilterBar = newState;
                API.setConditionAreaState({
                    state:newState,
                });
            },
        },
        beforeDestroy() {
            localStorage.removeItem('whitePage');
            // 销毁本页面resize监听
            window.removeEventListener('resize', this.resizePage)
        }

    }
</script>

<style lang="scss" scoped>
    .bg-color {
        background-color: #f8f8f9;
    }

    .page-wrap {
        display: flex;
        overflow: auto;
    }

    .left-wrap {
        padding: 1px;
        margin-right: 20px;
        /*transition: .3s;*/
        height: 100%;
        border: solid 1px #ccc;
        position: relative;
        background-color: #fff;
    }

    .right-content-wrap {
        position: relative;
        flex: 1;
        height: 100%;
        overflow-y: hidden;
        border-bottom: solid 1px #ccc;
        &.fixed-content{
            overflow-y: auto;
        }
    }

    .right-bottom {
        /*max-height: 500px;*/
        border: solid 1px #ccc;
        margin-top: 10px;
        background-color: #f8f8f9;
        overflow-y: hidden;
    }

    .right-top {
        position: relative;
        border: solid 1px #ccc;
        padding: 2px 10px;
        background-color: #fff;
    }

    .right-top-content {
        height: auto;
        overflow: hidden;
        margin-bottom: 10px;
    }

    .bg-color-white {
        background-color: #fff;
    }

    ::v-deep .tab-bar .el-tabs__item {
        font-weight: bold;
    }

    ::v-deep .tab-bar .el-tabs__header {
        margin: 0 0 10px;
    }

    .page-tips{
        right: 0;
        top: 12px;
        .underline{
            border-bottom-style: solid;
            border-bottom-width: 1px;
        }
    }

    .fix-tool{
        position: absolute;
        width: 15px;
        height: 24px;
        cursor: pointer;
        right: -15px;
        top: calc(45% + 60px);
        background-color: #fff;
        border: solid 1px #ccc;
        border-radius: 0 4px 4px 0;

        &.active{
            border: solid 1px #66b1ff;
        }

        span.icon{
            position: relative;
            top: 4px;
            right: 0;
            font-size: 12px;
        }
    }
</style>
